var exports = {
  "k": "xa15a2ab7--7d2b06--container",
};

module.exports = exports;
